export default "__VITE_ASSET__CIMA0PlF__"